<script lang="ts" setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';

import { resolveLandingVariant } from '@sigma/patient-common/landing/resolveLandingVariant.js';

import BenefitsSection from './components/BenefitsSection.vue';
import CtaSection from './components/CtaSection.vue';
import FaqSection from './components/FaqSection.vue';
import HeroSection from './components/HeroSection.vue';
import HowItWorksSection from './components/HowItWorksSection.vue';
import TrustSection from './components/TrustSection.vue';
import { landingVariants } from './landingVariants.js';

const route = useRoute();

// Variant is resolved purely from utm_campaign so SSR (we prerender the query URL) and the client agree —
// the served prerendered file matches what the client renders, with no hydration mismatch.
const variantContent = computed(() => {
  const utmCampaign = route.query.utm_campaign;
  const key = resolveLandingVariant(typeof utmCampaign === 'string' ? utmCampaign : undefined);
  return key ? landingVariants[key] : null;
});
</script>

<template>
  <main :class="css.main">
    <HeroSection
      v-if="variantContent"
      :heading="variantContent.heading"
      :subtitle="variantContent.subtitle"
      :cta="variantContent.cta"
    />
    <HeroSection v-else />
    <HowItWorksSection />
    <BenefitsSection />

    <!-- Divider -->
    <hr :class="css.divider" />

    <TrustSection />
    <FaqSection />
    <CtaSection />
  </main>
</template>

<style>
@import 'https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200&icon_names=acute,cognition,dew_point,lock,medical_services,prescriptions,psychology_alt,sweep,verified,verified_user,visibility_off,water_drop,work_history';
</style>

<style lang="scss" module="css">
.main {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.divider {
  border: none;
  height: 1px;
  padding: 0;
  margin: 0;
  max-width: none;
  background: linear-gradient(
    135deg,
    $color-patient-200 0%,
    $color-doctor-200 25%,
    $color-patient-200 50%,
    $color-doctor-200 75%,
    $color-patient-200 100%
  );
  animation: gradient-swipe 10s linear infinite;
  background-size: 400% 100%;
}
</style>
